module.exports = __webpack_public_path__ + "img/paperclip.png";